var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.nextTrainings),function(training){return _c('Training',{key:training.trainingId,attrs:{"data":training}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }